/* ============================================================
   trapincoming
   ============================================================ */

export const trapincoming = {
    id: "5",
    type: "playlist",
    featured: true,
    title: "Trap in comming",
    link: "favoritos",
    playlistBg: "#fc7272",
    imgUrl: "../image/listas/urbano/04.jpg", // /image/listas/img/trap-in-comming.jpg
    hoverColor: "#fc7272",
    artist: "mixtape",
    artistImgUrl: "../image/djs/mixtape/mixtape.png",
    artistBio: "Trap & more",
    artistDownload: "Descargar",
    bannerUno: "",
    downloadData: [],
    playlistData: [
      {
        id: "1",
        songName: "COSMETICOS",
        songimg: "../image/listas/urbano/10.jpg",
        songArtist: "Myke Towers",
        artistLink: "myke-towers",
        link: "https://dl.dropbox.com/scl/fi/t23ic6hbwow23wi8dglra/Myke-Towers-COSMETICOS.mp3?rlkey=vz8pcnbdy47xe77o5d9xblmfx&dl=1",
        trackTime: "2:22",
        promo: "../image/set/ali-palosanto4.jpg",
        promoCategory: 1
      },
      {
        id: "2",
        songName: "LA VUELTA",
        songimg: "../image/listas/urbano/04.jpg",
        songArtist: "Feid",
        artistLink: "feid",
        link: "https://dl.dropbox.com/scl/fi/hna0zj3vhl1tj0xz152kl/Feid-LA-VUELTA.mp3?rlkey=b7d9ka17k231cxmf8i0xd3ybe&dl=1",
        trackTime: "2:02"
      }
    ]
}